import React from 'react'
import * as PhosphorIcons from '@phosphor-icons/react'

const FaqValidatorViewResult = ({result}) => {
  const getQualityColor = (score) => {
    if (score >= 0.8) return 'bg-success/20 text-success';
    if (score >= 0.6) return 'bg-warning/20 text-warning';
    return 'bg-error/20 text-error';
  };

  const getComprehensiveColor = (level) => {
    // Return default if level is not a string
    if (typeof level !== 'string') {
      return 'bg-base-200 text-base-content';
    }

    switch(level.toLowerCase()) {
      case 'high':
        return 'bg-success/20 text-success';
      case 'medium':
        return 'bg-warning/20 text-warning';
      case 'low':
        return 'bg-error/20 text-error';
      default:
        return 'bg-base-200 text-base-content';
    }
  };

  return (
    <div className="mt-4 overflow-x-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* FAQ Analysis Section */}
        <div className="space-y-4">
          {/* Generated FAQs Card */}
          <div className="card bg-base-100 shadow-sm">
            <div className="card-body p-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="p-2 rounded-lg bg-primary/10">
                  <PhosphorIcons.Question size={20} weight="bold" className="text-primary"/>
                </div>
                <h3 className="card-title text-lg">Generated FAQs</h3>
              </div>

              <div className="space-y-3">
                {result?.faq_analysis?.generated_faqs?.map((faq, index) => (
                  <div key={index} className="p-3 bg-base-200 rounded-lg">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-medium text-primary">{faq.question}</span>
                      <div className="flex gap-2">
                        <span className={`px-2 py-0.5 rounded-full text-xs bg-primary/20 text-primary capitalize`}>
                          {faq.category}
                        </span>
                        <span className="px-2 py-0.5 rounded-full text-xs bg-success/20 text-success">
                          {Math.round(faq.confidence * 100)}%
                        </span>
                      </div>
                    </div>
                    <p className="text-sm text-base-content/80 mt-2">{faq.answer}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Metadata Section */}
        <div className="space-y-4">
          {/* Analysis Metrics Card */}
          <div className="card bg-base-100 shadow-sm">
            <div className="card-body p-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="p-2 rounded-lg bg-secondary/10">
                  <PhosphorIcons.ChartBar size={20} weight="bold" className="text-secondary"/>
                </div>
                <h3 className="card-title text-lg">Analysis Metrics</h3>
              </div>

              <div className="space-y-3">
                {/* Clarity Score */}
                {result?.faq_analysis?.metadata?.clarity_score != null && (
                  <div className="p-3 bg-base-200 rounded-lg">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-medium">Clarity Score</span>
                      <span className={`px-2 py-0.5 rounded-full text-xs ${getQualityColor(result.faq_analysis.metadata.clarity_score)}`}>
                        {Math.round(result.faq_analysis.metadata.clarity_score * 100)}%
                      </span>
                    </div>
                    <div className="w-full bg-base-300 rounded-full h-2">
                      <div 
                        className={`h-2 rounded-full ${getQualityColor(result.faq_analysis.metadata.clarity_score).replace('text-', 'bg-').replace('/20', '')}`}
                        style={{width: `${result.faq_analysis.metadata.clarity_score * 100}%`}}
                      ></div>
                    </div>
                  </div>
                )}

                {/* Comprehensiveness */}
                {result?.faq_analysis?.metadata?.comprehensiveness && (
                  <div className="p-3 bg-base-200 rounded-lg">
                    <div className="flex justify-between items-center">
                      <span className="font-medium">Comprehensiveness</span>
                      <span className={`px-2 py-0.5 rounded-full text-xs ${getComprehensiveColor(result.faq_analysis.metadata.comprehensiveness)}`}>
                        {result.faq_analysis.metadata.comprehensiveness}
                      </span>
                    </div>
                  </div>
                )}

                {/* Questions Generated */}
                {result?.faq_analysis?.metadata?.questions_generated != null && (
                  <div className="p-3 bg-base-200 rounded-lg">
                    <div className="flex justify-between items-center">
                      <span className="font-medium">Questions Generated</span>
                      <span className="px-2 py-0.5 rounded-full text-xs bg-info/20 text-info">
                        {result.faq_analysis.metadata.questions_generated}
                      </span>
                    </div>
                  </div>
                )}

                {/* Categories Covered */}
                {result?.faq_analysis?.metadata?.categories_covered?.length > 0 && (
                  <div className="p-3 bg-base-200 rounded-lg">
                    <span className="font-medium mb-2 block">Categories Covered</span>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {result.faq_analysis.metadata.categories_covered.map((category, index) => (
                        <span key={index} className="px-2 py-1 bg-base-300 rounded-full text-xs capitalize">
                          {category}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqValidatorViewResult;